<script setup lang="ts">
import { TableSurveys } from '@widgets/surveys'

import { useDisciplineSurveys } from '../model/discipline-surveys.hook'
import DisciplinePageLoader from './DisciplinePageLoader.vue'

defineOptions({
  name: 'DisciplineSurveysPage',
})

const { refIsFirstLoad } = useDisciplineSurveys()
</script>

<template>
  <DisciplinePageLoader :loading="refIsFirstLoad" />
  <TableSurveys is-discipline-page />
</template>
